import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import * as firebase from 'firebase';
import 'firebase/remote-config';
import { environment } from 'src/environments/environment';
import {ToolbarModule} from 'primeng/toolbar';
import {SplitButtonModule} from 'primeng/splitbutton';
import {PanelModule} from 'primeng/panel';
import {ToastModule} from 'primeng/toast';
import { LoginComponent } from './login/login.component';
import {MultiSelectModule} from 'primeng/multiselect';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MessageModule} from 'primeng/message';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {TabViewModule} from 'primeng/tabview';
import { HomeComponent } from './Home/home.component';
import {CardModule as cCardModule} from 'primeng/card';
import {CalendarModule} from 'primeng/calendar';
import {InputMaskModule} from 'primeng/inputmask';
import {NgxMaskModule} from 'ngx-mask';
import localeES from '@angular/common/locales/es';
import localeESExtra from '@angular/common/locales/extra/es';
import {registerLocaleData} from '@angular/common';
import {MenubarModule} from 'primeng/menubar';
import {MenuModule} from 'primeng/menu';
import { MenuComponent } from './Menu/menu.component';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import { ProfileComponent } from './profile/profile.component';
import { ContactComponent } from './contact/contact.component';
import { BenefitComponent } from './benefit/benefit.component';
import { AuthorizationComponent } from './authorization/authorization.component';
import { RegisterComponent } from './register/register.component';
import { OtpComponent } from './otp/otp.component';
import { ProvidersComponent } from './providers/providers.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CarouselModule} from 'primeng/carousel';
import { ProviderDetailComponent } from './provider-detail/provider-detail.component';
import {DataViewModule} from 'primeng/dataview';
import {DialogModule} from 'primeng/dialog';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import { ProviderOthersComponent } from './provider-others/provider-others.component';
import { TopbarAssitComponent } from './topbar-assit/topbar-assit.component';
import { FormsComponent } from './forms/forms.component';
import { NguiInViewComponent } from './ngui-in-view/ngui-in-view.component';
import { InteliSearchComponent } from './inteli-search/inteli-search.component';
import {RadioButtonModule} from 'primeng/radiobutton';
import {LandingComponent} from './Landing/landing.component';
import { TelemedicineComponent } from './telemedicine/telemedicine.component';
import { KurentoVideoComponent } from './kurento-video/kurento-video.component';
import { NgPaymentCardModule } from 'ng-payment-card';
import {SelectButtonModule} from 'primeng/selectbutton';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {FileUploadModule} from 'primeng/fileupload';
import {LoginActivate} from './LoginActivate';
import { ProviderLocationComponent } from './provider-location/provider-location.component';
import { ProviderWaitComponent } from './provider-wait/provider-wait.component';
import {AccordionModule} from 'primeng/accordion';
import {StepsModule} from 'primeng/steps';
import { PaymentComponent } from './payment/payment.component';
import { WaitListComponent } from './wait-list/wait-list.component';
import {TableModule} from 'primeng/table';
import {GalleriaModule} from 'primeng/galleria';

import { ConfirmationComponent } from './confirmation/confirmation.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { RenovationComponent } from './renovation/renovation.component';
import {AuthGuard} from './auth.guard';
import { SettingsComponent } from './settings/settings.component';
import { CouponsComponent } from './coupons/coupons.component';
import { HomeContentComponent } from './home-content/home-content.component';
//import { SplitterModule } from 'primeng/splitter';

import {ConfirmationService, MessageService} from 'primeng/api';
import {CheckboxModule} from 'primeng/checkbox';
import {TabMenuModule} from 'primeng/tabmenu';
import { EmergencyComponent } from './emergency/emergency.component';
import { IndividualComponent } from './individual/individual.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { DatePipe } from '@angular/common';
import { ImportantPhonesComponent } from './important-phones/important-phones.component';
import { DentalAssistanceComponent } from './dental-assistance/dental-assistance.component';
import { DentalAccessComponent } from './dental-access/dental-access.component';

import { CookieService } from 'ngx-cookie-service';
import {InputSwitchModule} from 'primeng/inputswitch';
import { ForgotIdComponent } from './forgot-id/forgot-id.component';
import { CannotLoginComponent } from './cannot-login/cannot-login.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { NewAuthorizationComponent } from './new-authorization/new-authorization.component';
import { LandingCMIComponent } from './landing-cmi/landing-cmi.component';
import { NewClaimComponent } from './new-claim/new-claim.component';
import { ClaimsComponent } from './claims/claims.component';
import { ProviderModuleComponent } from './provider-module/provider-module.component';


registerLocaleData(localeES);
firebase.initializeApp(environment.firebase);
firebase.analytics();
@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    LoginComponent,
    HomeComponent,
    MenuComponent,
    ProfileComponent,
    ContactComponent,
    BenefitComponent,
    AuthorizationComponent,
    RegisterComponent,
    OtpComponent,
    ProvidersComponent,
    ProviderDetailComponent,
    ProviderOthersComponent,
    TopbarAssitComponent,
    FormsComponent,
    NguiInViewComponent,
    InteliSearchComponent,
    TelemedicineComponent,
    KurentoVideoComponent,
    ProviderLocationComponent,
    ProviderWaitComponent,
    PaymentComponent,
    WaitListComponent,
    ConfirmationComponent,
    CheckoutComponent,
    RenovationComponent,
    SettingsComponent,
    CouponsComponent,
    HomeContentComponent,
    EmergencyComponent,
    IndividualComponent,
    EnterpriseComponent,
    ImportantPhonesComponent,
    DentalAssistanceComponent,
    DentalAccessComponent,
    ForgotIdComponent,
    CannotLoginComponent,
    GlossaryComponent,
    NewAuthorizationComponent,
    LandingCMIComponent,
    NewClaimComponent,
    ClaimsComponent,
    ProviderModuleComponent,
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        GraphQLModule,
        HttpClientModule,
        ApolloModule,
        HttpLinkModule,
        ToolbarModule,
        SplitButtonModule,
        PanelModule,
        ToastModule,
        FormsModule,
        MultiSelectModule,
        ButtonModule,
        DropdownModule,
        MessageModule,
        InputTextModule,
        InputTextareaModule,
        TabViewModule,
        ReactiveFormsModule,
        CalendarModule,
        InputMaskModule,
        NgxMaskModule,
        MenubarModule,
        MenuModule,
        OverlayPanelModule,
        AutoCompleteModule,
        CarouselModule,
        DataViewModule,
        DialogModule,
        BreadcrumbModule,
        RadioButtonModule,
        cCardModule,
        NgPaymentCardModule,
        SelectButtonModule,
        ProgressSpinnerModule,
        FileUploadModule,
        AccordionModule,
        StepsModule,
        CheckboxModule,
        TabMenuModule,
        TableModule,
        InputSwitchModule,
        GalleriaModule
        //SplitterModule,
    ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'es-ES' }, AuthGuard,
    {
    provide: APOLLO_OPTIONS,
    useFactory: (httpLink: HttpLink) => {

      return {
        cache: new InMemoryCache(),
        link: httpLink.create({
          uri: '\'https://provider-sync-cloud-staging.de1a.cloud.realm.io/graphql/%2FQASync-Provider\''
        })
      };
    },
    deps: [HttpLink]

  },
    LoginActivate,
    MessageService, ConfirmationService, CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
